import template from './subcontent.html';
import controller from './subcontent.controller';
import './subcontent.scss';

let subcontentComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default subcontentComponent;



// WEBPACK FOOTER //
// ./client/app/components/home/subcontent/subcontent.component.js